import React from 'react';
import Card from '../../../../shared/components/Card';
import { Role } from '../../../../shared/services/userService';
import usePageTranslation from '../../../../shared/hooks/usePageTranslation';

interface UserFiltersProps {
  searchTerm: string;
  selectedRole: number | '';
  roles: Role[];
  onSearchChange: (value: string) => void;
  onRoleChange: (value: number | '') => void;
}

const UserFilters: React.FC<UserFiltersProps> = ({
  searchTerm,
  selectedRole,
  roles,
  onSearchChange,
  onRoleChange
}) => {
  const { t } = usePageTranslation('panel', 'UserRolesManagement');

  return (
    <Card className="p-6 mb-6">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            {t('filters.search')}
          </label>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={t('filters.searchPlaceholder')}
            className="w-full px-4 py-2 bg-gray-800/50 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            {t('filters.role')}
          </label>
          <select
            value={selectedRole}
            onChange={(e) => onRoleChange(e.target.value ? Number(e.target.value) : '')}
            className="w-full px-4 py-2 bg-gray-800/50 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            <option value="">{t('filters.allRoles')}</option>
            {roles.map((role) => (
              <option key={role.id} value={role.id}>
                {role.role_name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </Card>
  );
};

export default UserFilters;

